const translation = {
    PageSize: '頁面大小',
    PageOrientation: '頁面方向',
    Format: '格式',
    DPI: '像素',
    Title: '匯出地圖',
    Close: '關閉',
    Save: '儲存',
    FileName: '檔案名稱',
    Landscape: '橫向',
    Portrait: '直向',
    PreviewHint: '在地圖上調整匯出範圍。',
    ExportFailed: '地圖匯出失敗，請再試一次。',
    PreviewFailed: '無法產生預覽。',
    AdjustArea: '在地圖上調整範圍',
    AdjustAreaHint: '移動、縮放、旋轉或傾斜地圖以框選匯出範圍',
    ZoomIn: '放大',
    ZoomOut: '縮小',
    ResetZoom: '重設為 100%',
    Done: '完成',
    Cancel: '取消',
    Scalebar: '比例尺',
    NorthIcon: '指北針',
    ChooseNorthIcon: '選擇指北針',
    ChooseSvgFile: '選擇 SVG 檔案',
    IconSymbol: '符號',
    IconColor: '顏色',
    IconSize: '大小',
    InvalidSvg: '該檔案不是有效的 SVG。',
    ExportAsVector: '匯出為向量',
    ExportLabelsAsVector: '將標註匯出為向量',
    Custom: '自訂',
    Width: '寬度',
    Height: '高度',
    LanguageName: '繁体字',
    LanguageCode: 'zhHant'
};
export default translation;
